import script from "./homeInfo.vue?vue&type=script&setup=true&lang=js"
export * from "./homeInfo.vue?vue&type=script&setup=true&lang=js"

import "./homeInfo.vue?vue&type=style&index=0&id=5a8b1882&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a8b1882"]])

export default __exports__